/* import __COLOCATED_TEMPLATE__ from './pix-toggle-button.hbs.js'; */
var _class;
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { action } from '@ember/object';
import { guidFor } from '@ember/object/internals';
import Component from '@glimmer/component';
let PixToggleButton = (_class = class PixToggleButton extends Component {
  get className() {
    const classes = ['pix-toggle-button'];
    if (this.args.toggled) {
      classes.push('pix-toggle-button--pressed');
    }
    if (this.args.inlineLabel) {
      classes.push('pix-toggle-button--inline');
    }
    return classes.join(' ');
  }
  onToggle() {
    this.args.onChange(!this.args.toggled);
  }
  get id() {
    return guidFor(this);
  }
}, _applyDecoratedDescriptor(_class.prototype, "onToggle", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onToggle"), _class.prototype), _class);
export { PixToggleButton as default };